const state = () => ({
    kycIncidents: {
        headers: [],
        data: [],
        pagination: {
            totalRowCount: 0,
            page: 1,
            itemsPerPage: 10,
            sortBy: "",
            sortDesc: true
        },
        tableOptions: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [true] },
        parameterDataMap: {},
        columnFilterType: "serverSide",
        loading: false,
        serviceResponseMessage: "",
        serviceResponseIsSuccess: false,
        pageOverlay: false,
        selectedIncidents: [],
        tableUniqueKey: null,
        columnVisibilityStatuses: {},
        responseCodeCounts: {}
    },
    myKycIncidents: {
        headers: [],
        data: [],
        pagination: {
            totalRowCount: 0,
            page: 1,
            itemsPerPage: 10,
            sortBy: "",
            sortDesc: true
        },
        tableOptions: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [true] },
        parameterDataMap: {},
        columnFilterType: "serverSide",
        loading: false,
        serviceResponseMessage: "",
        serviceResponseIsSuccess: false,
        pageOverlay: false,
        selectedIncidents: [],
        tableUniqueKey: null,
        columnVisibilityStatuses: {},
        responseCodeCounts: {}
    },
});

export default state;
